import React, { Component } from 'react';
import '../responsive/Comunicados.css';
import Footer from '../components/Principal/Footer';
import Header from '../components/Principal/Header';
import Seccion1 from '../components/Comunicados/Seccion1';
import Seccion2 from '../components/Comunicados/Seccion2';

class Comunicados extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <React.Fragment>
                <Header id={2} />
                <Seccion1 />
                <Seccion2 />
                <Footer />
            </React.Fragment>
        );
    }
}

export default Comunicados;